import { Inbox, Paperclip } from "lucide-react";
import { REGION_LABELS, STATUS_STYLES } from "../../lib/options";
import { formatDate, summaryFor } from "../../lib/format";

export const StatusBadge = ({ status, testId }) => (
  <span className={`inline-flex whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STATUS_STYLES[status] || ""}`} data-testid={testId}>{status}</span>
);

export const SubmissionTable = ({ items, loading, onOpen }) => {
  if (loading && items.length === 0) {
    return <div className="card-warm p-10 text-center text-sm text-[#5A6561]" data-testid="admin-loading">Loading submissions…</div>;
  }
  if (items.length === 0) {
    return (
      <div className="card-warm p-12 text-center" data-testid="admin-empty-state">
        <Inbox className="h-8 w-8 text-[#C86D51] mx-auto" />
        <p className="font-semibold mt-3">No submissions match these filters.</p>
        <p className="text-sm text-[#5A6561] mt-1">New submissions from the website will appear here.</p>
      </div>
    );
  }
  return (
    <div className="card-warm overflow-x-auto" data-testid="admin-submissions-table">
      <table className="w-full text-sm">
        <thead className="bg-[#FAF8F5] text-left text-xs uppercase tracking-wider text-[#5A6561]">
          <tr>
            {["Received", "Reference", "Name", "Location", "Summary", "Status"].map((h) => <th key={h} className="px-4 py-3 font-semibold whitespace-nowrap">{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {items.map((s) => (
            <tr key={s.id} onClick={() => onOpen(s.id)} className="border-t border-[#E5E0D8] hover:bg-[#FAF8F5] cursor-pointer transition-colors" data-testid={`admin-row-${s.reference}`}>
              <td className="px-4 py-3 whitespace-nowrap text-[#5A6561]">{formatDate(s.created_at)}</td>
              <td className="px-4 py-3 font-mono text-xs whitespace-nowrap">{s.reference}</td>
              <td className="px-4 py-3">
                <button type="button" className="font-semibold text-left hover:underline" data-testid={`admin-open-${s.id}`}>{s.name}</button>
                <div className="text-xs text-[#5A6561] break-all">{s.email}</div>
              </td>
              <td className="px-4 py-3 whitespace-nowrap">{s.city || "—"}<div className="text-xs text-[#5A6561]">{REGION_LABELS[s.region]}</div></td>
              <td className="px-4 py-3 max-w-[260px]">
                <span className="line-clamp-2">{summaryFor(s)}</span>
                <span className="flex gap-2 mt-1">
                  {s.resume && <span className="inline-flex items-center gap-1 text-xs text-[#5A6561]"><Paperclip className="h-3 w-3" />Resume</span>}
                  {s.interest_list && <span className="text-xs font-semibold text-[#1E3A2B]">Interest list</span>}
                </span>
              </td>
              <td className="px-4 py-3"><StatusBadge status={s.status} testId={`admin-status-badge-${s.id}`} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
